import { render, staticRenderFns } from "./WithdrawalTiming.vue?vue&type=template&id=3c1403f2&scoped=true&"
import script from "./WithdrawalTiming.vue?vue&type=script&lang=js&"
export * from "./WithdrawalTiming.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1403f2",
  null
  
)

export default component.exports